function getUsers({ state, output, services }) {
  services.Http
    .post('/api/users/get', state.get('client.fetchOptions'))
    .then(output.success)
    .catch(output.error)
}

getUsers.async = true
getUsers.outputs = ['success', 'error']

export default getUsers



// WEBPACK FOOTER //
// ./src/modules/user/actions/getUsers.js